// import { Annotorious, ImageAnnotator } from "@annotorious/react";
import { FC, memo } from "react";

import { Modal } from "#/molecules";
import { ViewPhotoProps } from "./ViewPhoto.interface";

const ViewPhoto: FC<ViewPhotoProps> = ({
  imageUrl,
  onClose
}) => {

    return (
        <Modal onClose={onClose} title="Portfolio Image" width="80vw" top="5%" maxHeight="90%">
        <div
            id="editor"
            style={{ width: "100%" }} >
                <img id="editImg" src={imageUrl} width={'100%'}></img>
        </div>
        </Modal>
    );
}

export default memo(ViewPhoto)